/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { SalesLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * Represents a product for order return.
 */
export class ReturnOrderProduct {
    public isSelected: boolean;

    public itemReturnQuantity: number;

    public readonly salesLine: SalesLine;

    public readonly simpleProduct: SimpleProduct;

    public constructor(salesLine: SalesLine, simpleProduct: SimpleProduct) {
        this.salesLine = salesLine;
        this.simpleProduct = simpleProduct;
        this.itemReturnQuantity = 0;
        this.isSelected = false;
    }
}